import { createFileRoute } from "@tanstack/react-router";
import { EventSearch } from "@/features/event-explorer/components/EventSearch";

export const Route = createFileRoute("/event-search/")({
  component: EventSearch,
});
